import { render, staticRenderFns } from "./PendingDomainsList.vue?vue&type=template&id=f069efb4&scoped=true"
import script from "./PendingDomainsList.vue?vue&type=script&lang=js"
export * from "./PendingDomainsList.vue?vue&type=script&lang=js"
import style0 from "./PendingDomainsList.vue?vue&type=style&index=0&id=f069efb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f069efb4",
  null
  
)

export default component.exports